import { Route, Routes } from 'react-router-dom';
import ShoppingPage from './components/ShoppingPage';
import Home from './components/Home';
import Products from './components/Products';
import Header from './components/Header';
import ProductDetails from './components/ProductDetails';

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path='/' element={<Home />}/>
        <Route path='/products' element={<Products />}/>
        <Route path='/shoppingpage' element={<ShoppingPage />}/>
        <Route path='/:id' element={<ProductDetails />}/>
      </Routes>
    </div>
  );
}

export default App;
